import onInit from "../utils/onInit";

onInit(() => {
  Array.prototype.forEach.call(document.querySelectorAll('.a-search-btn'), (el) => {
    el.addEventListener('click', (e) => {
      document.querySelector('#a-menu-search').classList.toggle('js-active');
      document.body.classList.add('body-locked')
    });
  });

  document.getElementById('a-menu-search-close-btn').addEventListener('click', (e) => {
    document.querySelector('#a-menu-search').classList.remove('js-active');
    document.body.classList.remove('body-locked')
  });
});
